module.exports = __webpack_public_path__ + "static/img/img_home_banner.58fcea6f.png";